import { useScreen } from 'hooks'

const useFooter = () => {
  const { xs } = useScreen()

  return { showFooter: xs }
}

export default useFooter
